

























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { AxiosRequestConfig } from 'axios';
import { FILE_UPLOAD } from '@/common/api';

const defaultFormData: Orders.IRejectForm = {
  rejectReason: '',
  attachments: [],
};

// eslint-disable-next-line no-use-before-define
@Component<RejectFormAttachments>({
  name: 'RejectFormAttachments',
})
export default class RejectFormAttachments extends Vue {
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  @Watch('show')
  toggleOpen(val): void {
    if (val) {
      this.open();
    } else {
      this.close();
    }
  }

  aufHeaders = [
    { name: 'Authorization', value: `Bearer ${this.$store.state.auth.token}` },
  ];

  formData: Orders.IRejectForm = { ...defaultFormData };

  visible: boolean = false;

  $refs!: {
    formData: any;
  };

  title: string = 'Отклонение заявления';

  async save(): Promise<void> {
    const isValid = await this.$refs.formData.validate();
    if (!isValid) return;
    const data = {
      attachments: this.formData.attachments,
      text: this.formData.rejectReason,
    };
    this.$emit('saved', data);
  }

  open(): void {
    this.visible = true;
    this.clearForm();
  }

  close(): void {
    this.visible = false;
    this.$emit('update:show', this.visible);
  }

  // eslint-disable-next-line class-methods-use-this
  uploaderFactory() {
    return FILE_UPLOAD;
  }

  addIds({ xhr: { response } }) {
    const { id } = JSON.parse(response);
    this.formData.attachments?.push(id);
  }

  clearForm() {
    this.formData = { ...defaultFormData };
  }
}
